import { createFileRoute } from '@tanstack/react-router';
import { CargosPage } from '@/components/cargos';

export const Route = createFileRoute('/_app/cadastros/cargos')({
  component: CargosPage,
});
